import { AppStyle } from 'decorators/withStyles';
import { setMargin, setPadding } from 'helpers/functions';

const styles: AppStyle = theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    height: 'fit-content',
    flexDirection: 'column',
    minHeight: '96.3vh',
  },
  content: {
    backgroundColor: '#f9fafb',
    minHeight: 'calc(100vh - 65px)',
    minWidth: '100%',
    padding: theme.variables.contentPadding,
    [theme.breakpoints.up('md')]: {
      padding: theme.variables.contentPaddingUpSm,
    },
    [theme.breakpoints.down('md')]: {
      ...setPadding(null, 16, null, 16),
    },
  },
  toolbar: theme.mixins.toolbar,
  footerDesktop: {
    ...setPadding(16, 0, 16, 20),
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    width: '100%',
    height: 65,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  logoEduzzDesktop: {
    width: '7%',
  },
  desktopText: {
    color: '#546E7A',
    ...setMargin(7, 0, 0, 10),
  },
  footerMobile: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    ...setPadding(15, 0, 15, 0),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  footerMobileImages: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    marginBottom: 5,
  },
  logoBlinket: {
    width: '20%',
  },
  logoEduzzMobile: {
    width: '25%',
  },
  footerMobileText: {
    color: '#546E7A',
    width: '100%',
    textAlign: 'center',
  },
});

export default styles;
